import React from 'react';
import ReactPlayer from 'react-player';

import * as style from './VideoPlayer360.module.less';

type VideoPlayer360Type = {
  url: string;
}

const PIXEL_THRESHOLD = 8;

const VideoPlayer360: React.FC<VideoPlayer360Type> = ({ url }) => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const [currentFrame, setCurrentFrame] = React.useState(0);
  const [duration, setDuration] = React.useState<number|undefined>();
  const [pointerDown, setPointerDown] = React.useState(false);
  const [posX, setPosX] = React.useState(0);

  const isOverThreshold = (value: number) => Math.trunc(value) % PIXEL_THRESHOLD === 0;

  const setNewFrame = (value: number) => {
    const newFrame = Math.round(value * 10) / 10;
    setCurrentFrame(newFrame);
    videoRef.current!.currentTime = newFrame;
  };

  const setPrevFrame = () => {
    if (duration) {
      const newFrame = currentFrame - 0.1;
      setNewFrame(newFrame < 0 ? duration : newFrame);
    }
  };

  const setNextFrame = () => {
    if (duration) {
      const newFrame = currentFrame + 0.1;
      setNewFrame(newFrame >= duration ? 0 : newFrame);
    }
  };

  const handleFrameMove = (direction: number, xScreenPos: number) => {
    if (direction > 0) {
      setNextFrame();
    } else if (direction < 0) {
      setPrevFrame();
    }
    setPosX(xScreenPos);
  };

  const handlePointerMove = (event: React.PointerEvent) => {
    event.preventDefault();
    event.stopPropagation();
    const direction = event.screenX - posX;
    switch (event.pointerType) {
      case 'mouse':
        if (event.buttons === 1 && isOverThreshold(event.screenX)) {
          handleFrameMove(direction, event.screenX);
        }
        break;
      case 'pen':
      case 'touch':
        if (isOverThreshold(event.screenX)) {
          handleFrameMove(direction, event.screenX);
        }
        break;
      default:
        break;
    }
  };

  const handleClick = (event: React.PointerEvent) => {
    setPosX(event.screenX);
    setPointerDown(true);
  };

  return (
    <div
      onPointerDown={handleClick}
      onPointerMove={handlePointerMove}
      className={style['video-container']}
      onPointerUp={() => setPointerDown(false)}
      style={{ cursor: pointerDown ? 'grabbing' : 'grab' }}
    >
      <i className={`${style['video-360-logo']} fb-icon--360-degree`} />
      <ReactPlayer
        src={url}
        width="auto"
        height="auto"
        ref={videoRef}
        disablePictureInPicture
        style={{ backgroundColor: 'black' }}
        onDurationChange={() => setDuration(videoRef.current!.duration)}
      />
    </div>
  );
};

export default VideoPlayer360;
